import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider } from '@/context/AuthContext'
import { PlayerProvider } from '@/context/PlayerContext'
import App from './App'
import './styles/tokens.css'
import './styles/global.css'

// ─── React Query ──────────────────────────────────────────────────────────────

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 2,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 1,
    },
  },
})

// ─── Root ─────────────────────────────────────────────────────────────────────

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root element #root not found in the DOM.')
}

/**
 * Provider order (outer → inner):
 *  QueryClientProvider  — data fetching cache
 *  BrowserRouter        — routing (must wrap AuthContext so hooks can navigate)
 *  AuthProvider         — Supabase session + backend user state
 *  PlayerProvider       — global video player state
 *  App                  — route tree
 */
ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <PlayerProvider>
            <App />
          </PlayerProvider>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
)
